import { addDays, type DateKey } from '@arrow/game-engine';

import { isReleased } from '../api/release.ts';

/** The hour (local) from which an open of Today fetches tomorrow's daily for the morning. */
export const EVENING_HOUR = 18;

/**
 * The day an open of Today at `now` should quietly fetch for the morning: tomorrow, from
 * 18:00 local, but only once the api has released it (tomorrow begins in UTC+14 at 10:00
 * UTC, so east of about UTC+8 the evening comes first); null otherwise. Asking earlier
 * would only get a 404. `localHour` is `now`'s hour on the device (a parameter for tests).
 */
export function dayToPrefetch(todayKey: DateKey, now: Date, localHour: number = now.getHours()): DateKey | null {
	if (localHour < EVENING_HOUR) return null;
	const tomorrow = addDays(todayKey, 1);
	return isReleased(tomorrow, now) ? tomorrow : null;
}
